import { unknown, z } from "zod";

export const QuizSettingsSchema = z.object({
    isActive: z.boolean(),
    time: z.number().min(0),
    veryHardCount: z.number().min(0),
    hardCount: z.number().min(0),
    mediumCount: z.number().min(0),
    easyCount: z.number().min(0),
})

export const QuestionBankServerResponseSchema = z.object({
    veryHardCount: z.number(),
    hardCount: z.number(),
    mediumCount: z.number(),
    easyCount: z.number(),
})

export const ExamSchema = z.object({
    id: z.number(),
    title: z.string(),
    dateLiteral: z.string(),
    date: z.string(),
    settings: z.unknown(),
    students: z.string(),
    isActive: z.boolean()
})

export const quizDefaultValues = {
    isActive: undefined,
    time: 15,
    veryHardCount: 1,
    hardCount: 4,
    mediumCount: 3,
    easyCount: 2
}

export const ExamServerResponseSchema = z.array(ExamSchema);

export type ExamType = z.infer<typeof ExamSchema>;
export type ExamServerResponseType = z.infer<typeof ExamServerResponseSchema>;